import { defineStore } from 'pinia';

interface LoadingState {
  loadingStates: Record<PropertyKey, Record<PropertyKey, boolean>>;
}

export const useLoadingStore = defineStore('loading', {
  state: (): LoadingState => ({
    loadingStates: {}
  }),

  actions: {
    setLoading(composableName: string, methodName: string, isLoading: boolean) {
      const newLoadingStates = { ...this.loadingStates };

      newLoadingStates[composableName] = {
        ...(newLoadingStates[composableName] || {}),
        [methodName]: isLoading
      };

      // Replace the entire loadingStates object to trigger reactivity
      this.loadingStates = newLoadingStates;
    }
  },

  getters: {
    isLoading: (state) => {
      return (composableName: string, methodName: string): boolean => {
        return Boolean(state.loadingStates[composableName]?.[methodName]);
      };
    },

    isAnyLoading: (state) => {
      return (composableName?: string): boolean => {
        if (composableName) {
          return Object.values(state.loadingStates[composableName] || {}).some(Boolean);
        }

        return Object.values(state.loadingStates).some((methodStates) => Object.values(methodStates).some(Boolean));
      };
    }
  }
});
